import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyBRL } from "../../../util/DoubleUtil";
import CantinaPageShared from "../CantinaPageShared";

const totalCupom = (itens = []) => itens.reduce((total, vc) => total + vc.precoVendido * vc.quantidade, 0);

const CupomCantinaPageView = ({ pageCupomCantina, handleChangePage, isLoading }) => (
  <CantinaPageShared
    page={pageCupomCantina}
    isLoading={isLoading}
    loadingText="Carregando compras..."
    emptyText="Nenhuma compra registrada."
    handleChangePage={handleChangePage}
  >
    <Stack spacing={1.5}>
      {pageCupomCantina.content.map((cupom) => (
        <Paper key={cupom.codigo} variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Stack direction="row" alignItems="center" spacing={1} px={2} py={1.25} sx={{ bgcolor: "action.hover" }}>
            <ReceiptLongOutlinedIcon fontSize="small" color="action" />
            <Typography variant="body2" fontWeight={500} flexGrow={1}>
              {dateTimeFormat(cupom.dataHoraCompra)}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {currencyBRL(totalCupom(cupom.listVendaCantina))}
            </Typography>
          </Stack>
          <Divider />
          <Table size="small" aria-label="Itens da compra">
            <TableHead>
              <TableRow sx={{ "& th": { color: "text.secondary", fontWeight: 500 } }}>
                <TableCell>Produto</TableCell>
                <TableCell align="right">Valor unit.</TableCell>
                <TableCell align="right">Qtd.</TableCell>
                <TableCell align="right">Subtotal</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(cupom.listVendaCantina ?? []).map((vc) => (
                <TableRow key={vc.codigo}>
                  <TableCell>{vc.produtoCantina?.descricao}</TableCell>
                  <TableCell align="right">{currencyBRL(vc.precoVendido)}</TableCell>
                  <TableCell align="right">{vc.quantidade}</TableCell>
                  <TableCell align="right">{currencyBRL(vc.precoVendido * vc.quantidade)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ))}
    </Stack>
  </CantinaPageShared>
);

export default CupomCantinaPageView;
